import React, { useMemo, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Notes from './Notes';
import { parseNotesJson, type NoteRow } from './parseNotes';

type NoteDraft = {
  note: string;
};

type NotesModalProps = {
  show: boolean;
  title: string;
  notesJson: string | null | undefined;
  showAdd?: boolean;
  onHide: () => void;
  onAdd?(draft: NoteDraft): void | Promise<void>;
};

const NotesModal: React.FC<NotesModalProps> = ({
  show,
  title,
  notesJson,
  showAdd = true,
  onHide,
  onAdd,
}) => {
  const [adding, setAdding] = useState(false);
  const noteRows = useMemo((): NoteRow[] => parseNotesJson(notesJson), [notesJson]);

  const handleAdd = async (draft: NoteDraft) => {
    if (!onAdd) {
      return;
    }
    setAdding(true);
    try {
      await onAdd(draft);
    } finally {
      setAdding(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Notes
          embedded
          notes={noteRows}
          showAdd={showAdd && onAdd != null}
          adding={adding}
          onAdd={onAdd != null ? handleAdd : undefined}
        />
      </Modal.Body>
    </Modal>
  );
};

export default NotesModal;
